import dayjs from './dayjs';

// "9:00 AM" / "12:15 pm" -> { hours: 9, minutes: 0 } (24-hour), or null when unparseable.
// Parsed by hand: Safari's Date parser rejects strings like "2026-10-28 9:00 AM".
export function parseTime12(time) {
    const match = /^\s*(\d{1,2}):(\d{2})\s*([AaPp][Mm])\s*$/.exec(String(time || ''));
    if (!match) return null;
    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours < 1 || hours > 12 || minutes > 59) return null;
    const pm = match[3].toUpperCase() === 'PM';
    if (hours === 12) hours = pm ? 12 : 0;
    else if (pm) hours += 12;
    return { hours, minutes };
}

// The calendar day the visitor clicked (a local-midnight Date) as YYYY-MM-DD
export function calendarDay(date) {
    return dayjs(date).format('YYYY-MM-DD');
}

// Start of the clicked day in the visitor's selected timezone, as a UTC ISO string
export function dayStartISO(date, timeZone) {
    return dayjs.tz(calendarDay(date), timeZone).toISOString();
}

// Timestamp (ms) of the clicked day + slot time, read in the visitor's selected timezone
export function bookingTimestamp(date, time, timeZone) {
    const parsed = parseTime12(time);
    if (!parsed) return NaN;
    const hh = String(parsed.hours).padStart(2, '0');
    const mm = String(parsed.minutes).padStart(2, '0');
    return dayjs.tz(`${calendarDay(date)}T${hh}:${mm}:00`, timeZone).valueOf();
}
